/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free word unscrambler and anagram solver. Enter your letters to find every word you can make — sorted by length. Perfect for Scrabble and Words With Friends.`)
};

const es_wu_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descifrador de palabras y solucionador de anagramas gratuito. Introduce tus letras para encontrar todas las palabras que puedes formar, ordenadas por longitud. Perfecto para Scrabble y Words With Friends.`)
};

const de_wu_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Wortentwirrer und Anagramm-Löser. Gib deine Buchstaben ein, um alle Wörter zu finden, die du bilden kannst – sortiert nach Länge. Perfekt für Scrabble und Words With Friends.`)
};

const nl_wu_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis woordontwarraar en anagramoplosser. Voer je letters in om elk woord te vinden dat je kunt maken — gesorteerd op lengte. Perfect voor Scrabble en Words With Friends.`)
};

const fr_wu_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déchiffreur de mots et solveur d'anagrammes gratuit. Saisissez vos lettres pour trouver tous les mots que vous pouvez former, triés par longueur. Idéal pour Scrabble et Words With Friends.`)
};

const it_wu_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sblocca parole e risolutore di anagrammi gratuito. Inserisci le tue lettere per trovare ogni parola che puoi formare, ordinate per lunghezza. Perfetto per Scrabble e Words With Friends.`)
};

const pt_br2_wu_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desembaralhador de palavras e solucionador de anagramas gratuito. Digite suas letras para encontrar todas as palavras que você pode formar — ordenadas por tamanho. Perfeito para Scrabble e Words With Friends.`)
};

const pt_wu_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbaralhador de palavras e resolvedor de anagramas gratuito. Introduza as suas letras para encontrar todas as palavras que pode formar — ordenadas por comprimento. Perfeito para Scrabble e Words With Friends.`)
};

const ja_wu_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の文字並べ替え・アナグラムソルバー。手持ちの文字を入力するだけで、作れるすべての単語を長さ順に表示します。Scrabble や Words With Friends に最適。`)
};

const zh_wu_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的字母重组与易位构词求解工具。输入你的字母，即可按长度顺序找到所有可以拼出的单词。非常适合 Scrabble 和 Words With Friends。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_hub_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_hub_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_hub_meta_description", locale)
	if (locale === "en") return en_wu_hub_meta_description(inputs)
	if (locale === "es") return es_wu_hub_meta_description(inputs)
	if (locale === "de") return de_wu_hub_meta_description(inputs)
	if (locale === "nl") return nl_wu_hub_meta_description(inputs)
	if (locale === "fr") return fr_wu_hub_meta_description(inputs)
	if (locale === "it") return it_wu_hub_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_wu_hub_meta_description(inputs)
	if (locale === "pt") return pt_wu_hub_meta_description(inputs)
	if (locale === "ja") return ja_wu_hub_meta_description(inputs)
	return zh_wu_hub_meta_description(inputs)
};